import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "c-section -white || o-padding -big-top -huge-bottom",
  "data-scroll-section": ""
}
const _hoisted_2 = { class: "o-container" }
const _hoisted_3 = { class: "o-grid -col-4 -col-8@from-medium -gutters c-sticky_section" }
const _hoisted_4 = { class: "o-grid_item u-gc-1/4@from-medium" }
const _hoisted_5 = {
  class: "o-padding -medium-bottom -no-padding-bottom@from-medium c-sticky_element",
  "data-scroll": "",
  "data-scroll-sticky": "",
  "data-scroll-target": "#target",
  "data-scroll-position": "top"
}
const _hoisted_6 = { class: "c-figure -lazy-load -no-bg || c-text-illu_figure -form || o-padding -medium-bottom -no-padding-bottom@from-medium" }
const _hoisted_7 = { class: "c-figure_inner" }
const _hoisted_8 = ["src", "data-src", "width", "height"]
const _hoisted_9 = { class: "o-grid_item u-gc-5/9@from-medium" }
const _hoisted_10 = { class: "c-form_title" }
const _hoisted_11 = { class: "c-form_item" }
const _hoisted_12 = { class: "c-form_item" }
const _hoisted_13 = {
  for: "FullName",
  class: "c-form_label -required"
}
const _hoisted_14 = { class: "c-form_item_group -group-1/2" }
const _hoisted_15 = { class: "c-form_item_group -group-1/2" }
const _hoisted_16 = { class: "c-form_item" }
const _hoisted_17 = { class: "c-form_item" }
const _hoisted_18 = { class: "c-form_item" }
const _hoisted_19 = { class: "c-form_item" }
const _hoisted_20 = { class: "c-form_item" }
const _hoisted_21 = { class: "c-form_item" }
const _hoisted_22 = { class: "c-form_controls" }
const _hoisted_23 = { class: "c-form_button_group" }
const _hoisted_24 = {
  class: "c-form_button_submit",
  type: "submit"
}
const _hoisted_25 = {
  key: 1,
  class: "c-form_success"
}
const _hoisted_26 = { class: "c-form_title" }
const _hoisted_27 = { class: "c-form_success_title" }
const _hoisted_28 = { class: "c-form_success_text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextInput = _resolveComponent("TextInput")
  const _component_EmailInput = _resolveComponent("EmailInput")
  const _component_PhoneInput = _resolveComponent("PhoneInput")
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_TextareaInput = _resolveComponent("TextareaInput")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", {
          id: "target",
          class: "c-sticky_target"
        }, null, -1 /* HOISTED */)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("figure", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  class: "c-figure_image",
                  src: 'data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 ' + $data.image.width + ' ' + $data.image.height + '\'%3E%3C/svg%3E',
                  "data-src": $data.image.url,
                  alt: "",
                  width: $data.image.width,
                  height: $data.image.height,
                  "data-scroll": "",
                  "data-scroll-call": "lazyLoad, Scroll"
                }, null, 8 /* PROPS */, _hoisted_8)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          ($data.submited != true)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                ref: "form$",
                onSubmit: _cache[0] || (_cache[0] = (...args) => ($options.checkForm && $options.checkForm(...args))),
                class: _normalizeClass(["c-form", { 'is-form-invalid': $data.formInvalid, 'is-loading': $data.loading, 'is-submited': $data.submited }]),
                novalidate: "true"
              }, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx._t("Partnerships inquiry")), 1 /* TEXT */),
                _createCommentVNode(" Company Name "),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_TextInput, {
                    id: "SingleLine-arialabel",
                    name: "Vendor_Name",
                    required: "true",
                    labelText: _ctx._t('Company Name')
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createCommentVNode(" Name "),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx._t("Name")), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_TextInput, {
                      id: "FirstName",
                      name: "First_Name",
                      required: "true",
                      labelText: _ctx._t('First name')
                    }, null, 8 /* PROPS */, ["labelText"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_TextInput, {
                      id: "LastName",
                      name: "Last_Name",
                      required: "true",
                      labelText: _ctx._t('Last name')
                    }, null, 8 /* PROPS */, ["labelText"])
                  ])
                ]),
                _createCommentVNode(" Email "),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_EmailInput, {
                    id: "Email",
                    name: "Email",
                    required: "true",
                    labelText: _ctx._t('Email')
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createCommentVNode(" Mobile "),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_PhoneInput, {
                    id: "Mobile",
                    name: "Mobile",
                    required: "true",
                    labelText: _ctx._t('Mobile')
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createCommentVNode(" Phone "),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_PhoneInput, {
                    id: "Phone",
                    name: "Phone",
                    labelText: _ctx._t('Phone')
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createCommentVNode(" Country "),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_SelectInput, {
                    id: "Country",
                    name: "Country",
                    required: "true",
                    labelText: _ctx._t('Country'),
                    options: [
                                { value: 'Afghanistan', text: 'Afghanistan' },
                                { value: 'Albania', text: 'Albania' },
                                { value: 'Algeria', text: 'Algeria' },
                                { value: 'Andorra', text: 'Andorra' },
                                { value: 'Angola', text: 'Angola' },
                                { value: 'Antigua and Barbuda', text: 'Antigua and Barbuda' },
                                { value: 'Argentina', text: 'Argentina' },
                                { value: 'Armenia', text: 'Armenia' },
                                { value: 'Australia', text: 'Australia' },
                                { value: 'Austria', text: 'Austria' },
                                { value: 'Azerbaijan', text: 'Azerbaijan' },
                                { value: 'Bahamas', text: 'Bahamas' },
                                { value: 'Bahrain', text: 'Bahrain' },
                                { value: 'Bangladesh', text: 'Bangladesh' },
                                { value: 'Barbados', text: 'Barbados' },
                                { value: 'Belarus', text: 'Belarus' },
                                { value: 'Belgium', text: 'Belgium' },
                                { value: 'Belize', text: 'Belize' },
                                { value: 'Benin', text: 'Benin' },
                                { value: 'Bhutan', text: 'Bhutan' },
                                { value: 'Bolivia', text: 'Bolivia' },
                                { value: 'Bosnia and Herzegovina', text: 'Bosnia and Herzegovina' },
                                { value: 'Botswana', text: 'Botswana' },
                                { value: 'Brazil', text: 'Brazil' },
                                { value: 'Brunei', text: 'Brunei' },
                                { value: 'Bulgaria', text: 'Bulgaria' },
                                { value: 'Burkina Faso', text: 'Burkina Faso' },
                                { value: 'Burundi', text: 'Burundi' },
                                { value: 'Cabo Verde', text: 'Cabo Verde' },
                                { value: 'Cambodia', text: 'Cambodia' },
                                { value: 'Cameroon', text: 'Cameroon' },
                                { value: 'Canada', text: 'Canada' },
                                { value: 'Central African Republic', text: 'Central African Republic' },
                                { value: 'Chad', text: 'Chad' },
                                { value: 'Chile', text: 'Chile' },
                                { value: 'China', text: 'China' },
                                { value: 'Colombia', text: 'Colombia' },
                                { value: 'Comoros', text: 'Comoros' },
                                { value: 'Congo (Congo-Brazzaville)', text: 'Congo (Congo-Brazzaville)' },
                                { value: 'Costa Rica', text: 'Costa Rica' },
                                { value: 'Croatia', text: 'Croatia' },
                                { value: 'Cuba', text: 'Cuba' },
                                { value: 'Cyprus', text: 'Cyprus' },
                                { value: 'Czech Republic', text: 'Czech Republic' },
                                { value: 'Democratic Republic of the Congo', text: 'Democratic Republic of the Congo' },
                                { value: 'Denmark', text: 'Denmark' },
                                { value: 'Djibouti', text: 'Djibouti' },
                                { value: 'Dominica', text: 'Dominica' },
                                { value: 'Dominican Republic', text: 'Dominican Republic' },
                                { value: 'Ecuador', text: 'Ecuador' },
                                { value: 'Egypt', text: 'Egypt' },
                                { value: 'El Salvador', text: 'El Salvador' },
                                { value: 'Equatorial Guinea', text: 'Equatorial Guinea' },
                                { value: 'Eritrea', text: 'Eritrea' },
                                { value: 'Estonia', text: 'Estonia' },
                                { value: 'Eswatini', text: 'Eswatini' },
                                { value: 'Ethiopia', text: 'Ethiopia' },
                                { value: 'Fiji', text: 'Fiji' },
                                { value: 'Finland', text: 'Finland' },
                                { value: 'France', text: 'France' },
                                { value: 'Gabon', text: 'Gabon' },
                                { value: 'Gambia', text: 'Gambia' },
                                { value: 'Georgia', text: 'Georgia' },
                                { value: 'Germany', text: 'Germany' },
                                { value: 'Ghana', text: 'Ghana' },
                                { value: 'Greece', text: 'Greece' },
                                { value: 'Grenada', text: 'Grenada' },
                                { value: 'Guatemala', text: 'Guatemala' },
                                { value: 'Guinea', text: 'Guinea' },
                                { value: 'Guinea-Bissau', text: 'Guinea-Bissau' },
                                { value: 'Guyana', text: 'Guyana' },
                                { value: 'Haiti', text: 'Haiti' },
                                { value: 'Honduras', text: 'Honduras' },
                                { value: 'Hungary', text: 'Hungary' },
                                { value: 'Iceland', text: 'Iceland' },
                                { value: 'India', text: 'India' },
                                { value: 'Indonesia', text: 'Indonesia' },
                                { value: 'Iran', text: 'Iran' },
                                { value: 'Iraq', text: 'Iraq' },
                                { value: 'Ireland', text: 'Ireland' },
                                { value: 'Israel', text: 'Israel' },
                                { value: 'Italy', text: 'Italy' },
                                { value: 'Jamaica', text: 'Jamaica' },
                                { value: 'Japan', text: 'Japan' },
                                { value: 'Jordan', text: 'Jordan' },
                                { value: 'Kazakhstan', text: 'Kazakhstan' },
                                { value: 'Kenya', text: 'Kenya' },
                                { value: 'Kiribati', text: 'Kiribati' },
                                { value: 'Kuwait', text: 'Kuwait' },
                                { value: 'Kyrgyzstan', text: 'Kyrgyzstan' },
                                { value: 'Laos', text: 'Laos' },
                                { value: 'Latvia', text: 'Latvia' },
                                { value: 'Lebanon', text: 'Lebanon' },
                                { value: 'Lesotho', text: 'Lesotho' },
                                { value: 'Liberia', text: 'Liberia' },
                                { value: 'Libya', text: 'Libya' },
                                { value: 'Liechtenstein', text: 'Liechtenstein' },
                                { value: 'Lithuania', text: 'Lithuania' },
                                { value: 'Luxembourg', text: 'Luxembourg' },
                                { value: 'Madagascar', text: 'Madagascar' },
                                { value: 'Malawi', text: 'Malawi' },
                                { value: 'Malaysia', text: 'Malaysia' },
                                { value: 'Maldives', text: 'Maldives' },
                                { value: 'Mali', text: 'Mali' },
                                { value: 'Malta', text: 'Malta' },
                                { value: 'Marshall Islands', text: 'Marshall Islands' },
                                { value: 'Mauritania', text: 'Mauritania' },
                                { value: 'Mauritius', text: 'Mauritius' },
                                { value: 'Mexico', text: 'Mexico' },
                                { value: 'Micronesia', text: 'Micronesia' },
                                { value: 'Moldova', text: 'Moldova' },
                                { value: 'Monaco', text: 'Monaco' },
                                { value: 'Mongolia', text: 'Mongolia' },
                                { value: 'Montenegro', text: 'Montenegro' },
                                { value: 'Morocco', text: 'Morocco' },
                                { value: 'Mozambique', text: 'Mozambique' },
                                { value: 'Myanmar (Burma)', text: 'Myanmar (Burma)' },
                                { value: 'Namibia', text: 'Namibia' },
                                { value: 'Nauru', text: 'Nauru' },
                                { value: 'Nepal', text: 'Nepal' },
                                { value: 'Netherlands', text: 'Netherlands' },
                                { value: 'New Zealand', text: 'New Zealand' },
                                { value: 'Nicaragua', text: 'Nicaragua' },
                                { value: 'Niger', text: 'Niger' },
                                { value: 'Nigeria', text: 'Nigeria' },
                                { value: 'North Korea', text: 'North Korea' },
                                { value: 'North Macedonia', text: 'North Macedonia' },
                                { value: 'Norway', text: 'Norway' },
                                { value: 'Oman', text: 'Oman' },
                                { value: 'Pakistan', text: 'Pakistan' },
                                { value: 'Palau', text: 'Palau' },
                                { value: 'Palestine', text: 'Palestine' },
                                { value: 'Panama', text: 'Panama' },
                                { value: 'Papua New Guinea', text: 'Papua New Guinea' },
                                { value: 'Paraguay', text: 'Paraguay' },
                                { value: 'Peru', text: 'Peru' },
                                { value: 'Philippines', text: 'Philippines' },
                                { value: 'Poland', text: 'Poland' },
                                { value: 'Portugal', text: 'Portugal' },
                                { value: 'Qatar', text: 'Qatar' },
                                { value: 'Romania', text: 'Romania' },
                                { value: 'Russia', text: 'Russia' },
                                { value: 'Rwanda', text: 'Rwanda' },
                                { value: 'Saint Kitts and Nevis', text: 'Saint Kitts and Nevis' },
                                { value: 'Saint Lucia', text: 'Saint Lucia' },
                                { value: 'Saint Vincent and the Grenadines', text: 'Saint Vincent and the Grenadines' },
                                { value: 'Samoa', text: 'Samoa' },
                                { value: 'San Marino', text: 'San Marino' },
                                { value: 'Sao Tome and Principe', text: 'Sao Tome and Principe' },
                                { value: 'Saudi Arabia', text: 'Saudi Arabia' },
                                { value: 'Senegal', text: 'Senegal' },
                                { value: 'Serbia', text: 'Serbia' },
                                { value: 'Seychelles', text: 'Seychelles' },
                                { value: 'Sierra Leone', text: 'Sierra Leone' },
                                { value: 'Singapore', text: 'Singapore' },
                                { value: 'Slovakia', text: 'Slovakia' },
                                { value: 'Slovenia', text: 'Slovenia' },
                                { value: 'Solomon Islands', text: 'Solomon Islands' },
                                { value: 'Somalia', text: 'Somalia' },
                                { value: 'South Africa', text: 'South Africa' },
                                { value: 'South Korea', text: 'South Korea' },
                                { value: 'South Sudan', text: 'South Sudan' },
                                { value: 'Spain', text: 'Spain' },
                                { value: 'Sri Lanka', text: 'Sri Lanka' },
                                { value: 'Sudan', text: 'Sudan' },
                                { value: 'Suriname', text: 'Suriname' },
                                { value: 'Sweden', text: 'Sweden' },
                                { value: 'Switzerland', text: 'Switzerland' },
                                { value: 'Syria', text: 'Syria' },
                                { value: 'Taiwan', text: 'Taiwan' },
                                { value: 'Tajikistan', text: 'Tajikistan' },
                                { value: 'Tanzania', text: 'Tanzania' },
                                { value: 'Thailand', text: 'Thailand' },
                                { value: 'Timor-Leste', text: 'Timor-Leste' },
                                { value: 'Togo', text: 'Togo' },
                                { value: 'Tonga', text: 'Tonga' },
                                { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
                                { value: 'Tunisia', text: 'Tunisia' },
                                { value: 'Turkey', text: 'Turkey' },
                                { value: 'Turkmenistan', text: 'Turkmenistan' },
                                { value: 'Tuvalu', text: 'Tuvalu' },
                                { value: 'Uganda', text: 'Uganda' },
                                { value: 'Ukraine', text: 'Ukraine' },
                                { value: 'United Arab Emirates', text: 'United Arab Emirates' },
                                { value: 'United Kingdom', text: 'United Kingdom' },
                                { value: 'United States', text: 'United States' },
                                { value: 'Uruguay', text: 'Uruguay' },
                                { value: 'Uzbekistan', text: 'Uzbekistan' },
                                { value: 'Vanuatu', text: 'Vanuatu' },
                                { value: 'Vatican City', text: 'Vatican City' },
                                { value: 'Venezuela', text: 'Venezuela' },
                                { value: 'Vietnam', text: 'Vietnam' },
                                { value: 'Yemen', text: 'Yemen' },
                                { value: 'Zambia', text: 'Zambia' },
                                { value: 'Zimbabwe', text: 'Zimbabwe' }
                            ]
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createCommentVNode(" Partner Type "),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_SelectInput, {
                    id: "Dropdown2-arialabel",
                    name: "Vendor_Type",
                    labelText: _ctx._t('Partner Type'),
                    options: [
                                //{ value: 'External ISO', text: 'External ISO (VAR)' },
                                { value: 'External ISO1', text: 'External ISO' },
                                //{ value: 'Partner', text: 'Referral Partner (VAR)' },
                                { value: 'Referral Partner', text: 'Referral Partner' },
                                { value: 'Value Added Provider', text: 'Value Added Solution' },
                                { value: 'Advisor', text: 'Advisor (ISA)' },
                                { value: 'Service Provider', text: 'Service Provider' },
                                { value: 'other', text: 'Other - Specify in the notes section' }, 
                                //{ value: 'Internal ISO', text: 'Internal ISO' }
                            ]
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createCommentVNode(" Textarea "),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_TextareaInput, {
                    id: "MultiLine-arialabel",
                    name: "Description",
                    labelText: _ctx._t('Tell us about your organization, and what you like to achieve with PandaPay')
                  }, null, 8 /* PROPS */, ["labelText"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("button", _hoisted_24, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "c-form_button_spinner" }, null, -1 /* HOISTED */)),
                      _createTextVNode(" " + _toDisplayString(_ctx._t("Submit")), 1 /* TEXT */)
                    ])
                  ])
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("input", {
                  type: "hidden",
                  name: "Partnership_status",
                  value: "Prospect"
                }, null, -1 /* HOISTED */)),
                _cache[3] || (_cache[3] = _createElementVNode("input", {
                  type: "hidden",
                  name: "Partner_Source",
                  value: "Website"
                }, null, -1 /* HOISTED */))
              ], 34 /* CLASS, NEED_HYDRATION */))
            : _createCommentVNode("v-if", true),
          ($data.submited==true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx._t("Thank you")), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx._t("Your information has been submitted")), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx._t("We will be in touch shortly")), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}